export function timeFormat(distance) {
  if (distance) {
    var days = Math.floor(distance / (1000 * 60 * 60 * 24))
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60) + days * 24
    )
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    var seconds = Math.floor((distance % (1000 * 60)) / 1000)
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
  } else {
    return 'Cargando...'
  }
}
// export function to return a now utc Date in ISO format
export function addZero(i) {
  if (i < 10) {
    i = '0' + i
  }
  return i
}
